import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/default.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const TitleLarge = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlnsa="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
        x="0px"
        y="0px"
        width="320px"
        height="5px"
        viewBox="0 0 320 5"
        xmlSpace="preserve"
        className={classNames([styles.container, { [className]: className !== null }])}
    >
        <g>
            <path
                fill={color}
                d="M316.6,1c-0.4-0.1-0.8-0.3-0.9-0.3c-0.6,0.1-0.8,0-1-0.2c-0.4-0.5-1.6-0.1-2.4-0.3c-1,0.6-2,0-3,0
    		c-0.6,0.1-1.4,0.3-1.9,0.2c-1.5-0.3-3.1-0.2-4.5-0.1c-1,0-1.5,0-2.1-0.4c-0.2,0.3-0.4,0.6-0.6,0.9c-1.8-0.7-3.7-0.7-5.8-0.4
    		c-0.4-0.2-0.7-0.3-1.1-0.4c-0.4,0.1-0.7,0.2-1.1,0.3c-0.3,0.1-0.6,0.1-1.3,0.3c-0.2-0.2-0.4-0.3-0.4-0.3c-1.3,0.1-2.4,0.3-3.1,0.2
    		c-1.7-0.2-3.1-0.1-4.7,0c-1.6,0.1-3.4,0.3-4.5-0.2c-0.8,0.1-1.4,0.2-1.9,0.2c-0.6,0-1.2-0.1-1.8-0.2c-0.4,0.3-1,0.5-2,0.4
    		c-0.7-0.1-1.3-0.2-2-0.3c-1-0.1-2-0.1-2.4,0.3c-0.9-0.2-1.6-0.4-2.3-0.5c-0.5,0.2-0.9,0.4-1.4,0.6c-0.2-0.2-0.4-0.4-0.5-0.6
    		c-0.9,0-1.8-0.1-1.7,0.4c-0.7,0-1.3,0-1.9,0c-0.5,0-1,0.1-1.3,0.1c-1.1-0.2-2.2-0.4-3.4,0c-0.1,0-0.3,0-0.4,0
    		c-0.8-0.2-1.8-0.1-2.6-0.1c-0.4,0-0.8-0.2-1.2-0.3c-1.4,0.3-1.4,0.3-4.5,0c-0.1,0.2-0.1,0.3-0.2,0.5c-2.2-0.2-4.4-0.5-6.6-0.1
    		c-1.6-0.3-3.6,0.3-4.7-0.3c-0.8,0.1-1.5,0.2-2.1,0.3c-0.4-0.2-0.8-0.3-1.2-0.5c-0.3,0.2-0.6,0.4-0.6,0.4c-1.2-0.1-2.2-0.2-3.2-0.1
    		c-1.1,0.1-2.1,0.1-3-0.2c-0.3-0.1-0.7-0.1-1.1-0.2c-0.1,0.2-0.2,0.4-0.3,0.6c-1.1-0.1-2.1-0.3-3.1-0.4c-0.1,0-0.3,0-0.4,0.1
    		c-0.5,0.2-1.1,0.3-1.6,0.5c-0.1-0.1-0.4-0.2-0.6-0.4c-0.7,0.1-1.4,0.2-1.9,0.2c-0.5,0-0.9-0.2-1.1-0.3c-0.8,0.1-1.5,0.3-2.2,0.3
    		c-2.8-0.1-5.6,0-8.3-0.2c-0.4,0-0.9-0.1-1.1,0c-1.7,0.6-3.7-0.1-5.4,0.1c-1.3-0.6-2.1-0.1-3,0.3c-1-0.5-2.1-0.7-3.5-0.2
    		c-0.2,0.1-0.6,0.1-0.9,0.1c-1.5-0.2-2.5,0.1-3.4,0.4c-0.3-0.2-0.5-0.4-0.6-0.4c-1.7,0.2-3.3-0.1-4.8-0.1c-2,0-4.1,0.4-6.2,0.1
    		c-1.3,0.3-2.4,0-3.5-0.1c-0.4,0-1.2-0.1-1.3-0.1c-1.1,0.6-2,0.1-3,0c-1.9,0.4-2.1,0.3-2.3-0.4c-0.5,0.3-0.9,0.5-1.5,0.8
    		c-1.2-0.6-3.1,0.1-4.3-0.4c-0.3,0.2-0.6,0.4-0.8,0.7c-1-0.3-1.8-0.5-2.7-0.8c-1.5,0.5-3.2,0-4.8,0.1c0,0.1,0,0.2,0,0.3
    		c-1.5,0.1-2.6,0-3.4-0.5c-0.9,0.1-1.5,0.7-2.6,0.4c-1.5-0.4-1.7,0.1-2.4,0.4c-0.8-0.3-1.3-0.9-2.7-0.2c-0.4-0.2-0.8-0.4-1.1-0.6
    		c-0.9,0.2-1.4,0.3-2,0.4c-0.2-0.1-0.5-0.2-0.6-0.3c-0.8,0.1-1.6,0.3-2.4,0.4c-0.3-0.1-0.5-0.3-0.8-0.4c-0.5,0.2-0.9,0.3-1.6,0.6
    		c-0.3-0.2-0.5-0.4-0.8-0.6c-1.5,0.5-2.9,0.6-4.2,0.4c-1.9-0.3-3.7-0.2-5.3,0c-0.9-0.1-1.7-0.1-2.3-0.2c-1-0.2-1.2,0.4-2.1,0.2
    		c-0.4-0.2-0.8-0.3-1.2-0.5c-0.8,0.2-1.4,0.4-2,0.6c-0.9-0.2-1.8-0.3-2.8-0.5c-0.3,0.2-0.6,0.3-0.9,0.4c-0.5,0-0.9-0.1-1.4-0.1
    		c-0.5,0-1.1,0-1.6-0.1c-1.1-0.1-2.2-0.4-3,0.2c-1.2-0.3-2.8,0.1-4-0.3c-0.5-0.2-1.1-0.2-1.3,0.1c-0.2,0.3-0.7,0.2-1.3,0.3
    		c-0.4,0-0.7,0.2-1,0.3c-0.2-0.1-0.5-0.1-0.7-0.2c-0.3-0.1-0.5-0.2-0.5-0.2c-0.4,0.1-0.8,0.2-1.1,0.2c-0.8,0-1.6-0.2-2.5-0.2
    		c-1.4-0.1-2,0.1-2.6,0.7c0,0-0.3,0.1-0.6,0.1c0-0.3,0.1-0.5,0.1-0.9c-0.7,0.1-1.2,0.1-1.7,0.2c-0.4,0-1,0.1-1.2,0.1
    		c-0.4-0.1-0.5-0.3-0.8-0.6c-0.7,0.2-1.4,0.4-2.2,0.6c-0.7,0-1.5-0.1-2.3-0.2c-1.9-0.2-1.9-0.3-3,0.3c-0.7-0.4-1.9-0.5-2.8-0.3
    		c-0.9,0.1-1.6,0.1-2.4,0c-1.1,0-2.1-0.1-3.2,0.1c-0.7,0.1-1.3,0-1.9-0.1c-1-0.2-1.5-0.1-1.8,0.3c-2.2,0.3-3.8-0.4-5.9-0.5
    		c0.2,0.2,0.3,0.3,0.5,0.5c-1.7,0.2-2.5-0.1-3-0.6c-1,0.3-1.3,0.3-2.7,0.2c-0.2,0-0.5,0-0.6,0c-0.8,0.4-1.6,0.2-2.4,0
    		c-0.4-0.1-1.4-0.1-1.5,0c-0.3,0.4-1.4,0.2-1.6,0.2c-1,0.4-1.5-0.2-2.3-0.1c-0.8,0.1-1.6,0.3-2.6,0c-0.5-0.2-1.9,0-2.8,0
    		c-1.2,0.1-2.1-0.1-3.2-0.4c-0.3,0.2-0.5,0.3-0.7,0.4c-0.8-0.2-1.3-0.4-2-0.5c-0.8,0.7-2,0.6-3.4,0.3c-0.6-0.1-1.2-0.1-1.9-0.2
    		c0.2,0.2,0.4,0.4,0.6,0.6c-1-0.1-2.1,0-2.4-0.2c-1.1-0.5-1.8-0.3-3,0c-1,0.2-2.5,0.2-3.8,0.2c-0.6,0-1.2-0.3-1.8-0.5
    		c-1.1,0.4-2,0.6-2.9,0.4c-1.4-0.2-4.1-0.2-5.3-0.1c-1,0.1-1.7,0-2-0.4c0-0.1-0.3-0.1-0.6-0.2c0,0.2,0,0.3,0,0.4
    		C6.2,0.6,4.6,0.5,3.4,0.4C2.6,0.7,2,0.9,1.5,1C1,1.3,0.1,1.5,0,1.7l1.9,0.4c1.2,0.1,2.8,0.1,4.6,0.2c0-0.2,0-0.3,0-0.5
    		C6.8,2,7.1,2,7.1,2.1c0.3,0.4,1,0.5,2.1,0.4c0.5-0.1,1.3-0.1,2.2-0.1c0.1,0,0.3,0,0.5,0c0,0,0,0,0,0c1,0,2.1,0.1,2.8,0.2
    		c0.9,0.1,1.8,0,3-0.5c0.6,0.2,1.3,0.5,1.9,0.5c1.3,0,2.9,0,3.9-0.2c1.3-0.3,2-0.5,3.1,0c0.4,0.2,1.5,0.1,2.5,0.2
    		c-0.2-0.2-0.4-0.4-0.6-0.6c0.8,0.1,1.4,0.1,2,0.2c1.4,0.2,2.7,0.3,3.5-0.4c0.1,0,0.2,0.1,0.3,0.1c0,0,0,0,0,0
    		c0-0.1,0.2-0.1,0.5-0.2C34.9,1.9,35,2,34.9,2.1c0,0,0,0-0.1,0c0.4,0.1,0.8,0.2,1.2,0.3c0.2-0.1,0.5-0.3,0.8-0.5
    		c1.1,0.2,2,0.5,3.3,0.4c1-0.1,2.4-0.2,2.9,0c1,0.3,1.9,0.1,2.7,0.1c0.9-0.1,1.4,0.5,2.4,0.1c0.2-0.1,1.3,0.2,1.6-0.3
    		c0,0,0.2,0,0.4,0C50.1,2,50,2,50,1.9c0-0.1,0.2-0.1,0.3-0.2c0.1,0.1,0.3,0.1,0.4,0.2c0,0-0.1,0.1-0.2,0.2c0.3,0,0.7,0,0.9,0.1
    		c0.9,0.2,1.7,0.4,2.5,0c0.1,0,0.4,0,0.6,0c1.5,0.1,1.8,0,2.8-0.2c0.6,0.5,1.4,0.8,3.1,0.6c-0.2-0.2-0.3-0.3-0.5-0.5
    		c2.2,0.1,3.9,0.8,6.1,0.5c0.3-0.4,0.8-0.5,1.9-0.3c0.6,0.1,1.2,0.2,1.9,0.1c1.1-0.2,2.2-0.1,3.3-0.1c0.8,0,1.6,0.1,2.5,0
    		c1-0.2,2.3-0.1,2.9,0.4C79.7,2,79.7,2,81.6,2.3c0.8,0.1,1.7,0.1,2.4,0.2c0.8-0.2,1.5-0.4,2.3-0.7c0.3,0.3,0.5,0.5,0.8,0.6
    		c0.2,0.1,0.8,0,1.3-0.1c0.5,0,1-0.1,1.8-0.2c0,0.3-0.1,0.6-0.1,0.9c0.3,0,0.6-0.1,0.7-0.1c0.6-0.6,1.2-0.8,2.7-0.7
    		c0.9,0,1.7,0.2,2.6,0.2c0.3,0,0.7-0.1,1.2-0.2c0.1,0,0.3,0.1,0.6,0.2c0.2,0.1,0.5,0.2,0.7,0.2c0.3-0.1,0.6-0.3,1-0.3
    		c0.6,0,1.1,0,1.3-0.3c0.2-0.3,0.8-0.3,1.3-0.1c1.2,0.4,2.9,0,4.1,0.3c0.8-0.6,2-0.3,3.1-0.2c0.5,0,1.1,0,1.7,0.1
    		c0.5,0,0.9,0,1.4,0.1c0.3-0.1,0.6-0.3,0.9-0.4c1,0.2,1.9,0.3,2.9,0.5c0.7-0.2,1.3-0.4,2.1-0.6c0.4,0.2,0.8,0.3,1.2,0.5
    		c0.9,0.2,1.2-0.4,2.2-0.2c0.7,0.1,1.5,0.1,2.4,0.2c1.7-0.2,3.5-0.4,5.5-0.1c1.3,0.2,2.9,0.1,4.4-0.4c0.3,0.2,0.5,0.4,0.8,0.6
    		c0.7-0.3,1.1-0.4,1.6-0.6c0.4,0.2,0.6,0.3,0.9,0.5c0.8-0.2,1.7-0.3,2.5-0.5c0.1,0.1,0.3,0.2,0.6,0.3c0.6-0.1,1.1-0.2,2.1-0.4
    		c0.3,0.2,0.7,0.4,1.1,0.6c0,0,0,0,0.1,0c-0.3-0.2-0.1-0.4,0.1-0.7c0.2,0.2,0.4,0.3,0.5,0.5c0.9-0.2,1.4,0.3,2.1,0.5
    		c0.7-0.3,0.8-0.8,2.4-0.4c1.2,0.3,1.8-0.3,2.7-0.4c0.8,0.5,2,0.6,3.5,0.5c0-0.1,0-0.2,0-0.4c1.6-0.2,3.4,0.4,5-0.1
    		c1,0.3,1.8,0.5,2.8,0.8c0.3-0.2,0.6-0.4,0.9-0.7c1.3,0.6,3.3-0.1,4.5,0.5c0.5-0.3,1-0.5,1.5-0.8c0.2,0.7,0.4,0.8,2.4,0.4
    		c1,0.2,1.9,0.7,3.1,0c0.1-0.1,0.9,0,1.3,0.1c0.9,0.1,1.9,0.3,2.9,0.2c0.2,0,0.4-0.1,0.5-0.1c0,0,0,0,0,0c0.1,0,0.2,0,0.3,0
    		c2.2,0.3,4.3-0.1,6.4-0.1c1.6,0,3.3,0.2,5,0.1c0.1,0,0.4,0.2,0.6,0.4c1-0.4,2.1-0.7,3.6-0.5c0.3,0,0.7,0,0.9-0.1
    		c1.4-0.4,2.5-0.2,3.6,0.3c0.9-0.3,1.7-0.9,3.1-0.3c1.8-0.2,3.8,0.5,5.6-0.1c0.2-0.1,0.8,0,1.2,0c2.8,0.3,5.7,0.1,8.6,0.2
    		c0.7,0,1.4-0.2,2.2-0.3c0.3,0.1,0.7,0.3,1.1,0.3c0.6,0,1.2-0.1,2-0.2c0.2,0.1,0.5,0.3,0.6,0.4c0.6-0.2,1.1-0.3,1.7-0.5
    		c0.1,0,0.3,0,0.4-0.1c1,0.1,2.1,0.3,3.2,0.4c0.1-0.3,0.2-0.4,0.3-0.6c0.4,0.1,0.8,0.1,1.1,0.2c1,0.3,2,0.2,3.1,0.2
    		c1-0.1,2,0.1,3.3,0.1c0.1,0,0.3-0.2,0.7-0.4c0.5,0.2,0.8,0.3,1.3,0.5c0.3,0,0.6-0.1,0.9-0.1c-0.1-0.1-0.2-0.1-0.4-0.2
    		c0.5,0,0.8,0,1.1,0.1c0.2,0,0.3,0,0.5-0.1c0.1,0,0.1,0.1,0.2,0.1c-0.3-0.3,0.1-0.4,1-0.6c0.1,0.2,0.1,0.4,0.2,0.6
    		c-0.5,0-0.8,0-1.1,0c1.2,0.4,3.1-0.1,4.6,0.2c2.3-0.4,4.5-0.1,6.8,0.1c0.1-0.2,0.1-0.3,0.2-0.5c3.1,0.3,3.1,0.3,4.6,0
    		c0.4,0.1,0.8,0.2,1.3,0.3c0.9,0.1,1.9-0.1,2.7,0.1c0.1,0,0.4,0,0.5,0c1.2-0.4,2.3-0.1,3.5,0c0.4,0.1,0.9,0,1.4-0.1
    		c0.6,0,1.2,0,1.9,0c-0.1-0.5,0.8-0.4,1.8-0.4c0.1,0.2,0.3,0.3,0.5,0.6c0.6-0.2,1-0.4,1.5-0.6c0.8,0.2,1.5,0.4,2.4,0.6
    		c0.4-0.5,1.4-0.4,2.4-0.4c0.7,0.1,1.4,0.2,2.1,0.3c1.1,0.1,1.7,0,2.1-0.4c0.6,0.1,1.3,0.2,1.9,0.2c0.6,0,1.2-0.1,2-0.2
    		c1.1,0.6,3,0.3,4.7,0.2c1.7-0.1,3.2-0.2,4.9,0c0.8,0.1,1.9-0.1,3.2-0.2c0,0,0.2,0.2,0.4,0.4c0.7-0.1,1-0.2,1.3-0.3
    		c0.3-0.1,0.7-0.2,1.1-0.3c0.4,0.1,0.7,0.3,1.1,0.4c2.1-0.4,4.2-0.4,6,0.4c0.2-0.4,0.4-0.6,0.7-1c0.6,0.4,1.2,0.5,2.2,0.4
    		c1.5-0.1,3.1-0.2,4.7,0.1c0.4,0.1,1.3-0.1,1.9-0.2c0.4,0,0.8,0.1,1.2,0.1c0-0.1,0-0.2,0-0.2c-0.1-0.4-0.4-0.7-1.6-0.8
    		c-0.4-0.1-0.7-0.2-1.1-0.2C317.1,0.8,316.7,1.1,316.6,1z M12.8,1.9c-1,0.1-1.5,0-1.2-0.5C12.2,1.6,12.4,1.8,12.8,1.9z M18.6,1.2
    		c-0.2,0-0.3-0.1-0.5-0.1C18.2,1,18.3,1,18.5,0.9C18.7,1,18.9,1,19,1.1C18.9,1.1,18.8,1.2,18.6,1.2z M26.3,1.9c0,0-0.2,0-0.4,0
    		c0-0.1-0.1-0.2-0.1-0.3c0.2,0,0.4,0,0.6,0C26.3,1.6,26.3,1.7,26.3,1.9z M31.8,1.7c-0.3-0.4-0.3-0.4,0.9-0.4
    		C32.4,1.4,32.2,1.5,31.8,1.7z M53.5,2.2c0,0.1-0.3,0.1-0.4,0.1c-0.1-0.1-0.2-0.1-0.2-0.2c0-0.1,0.2-0.1,0.4-0.2
    		C53.4,2.1,53.6,2.2,53.5,2.2z M56.4,1.2c-0.2,0-0.4-0.1-0.6-0.2c0.2,0,0.3-0.1,0.6-0.2c0.2,0.1,0.4,0.2,0.5,0.2
    		C56.7,1.1,56.5,1.2,56.4,1.2z M66.5,1.9C66.3,2,66.2,2,66.1,2.1c-0.1-0.1-0.4-0.1-0.4-0.2c0-0.1,0.2-0.1,0.3-0.2
    		C66.1,1.8,66.3,1.8,66.5,1.9z M143.8,1.7c-0.9,0.1-1.1,0-0.9-0.5C143.3,1.5,143.6,1.6,143.8,1.7z M183.6,1.5
    		c0.3-0.3,0.7-0.5,1.8-0.3C185,1.4,184.8,1.7,183.6,1.5z"
            />
            <path
                fill={color}
                d="M147.3,3.5c-0.2-0.1-0.5-0.2-0.9-0.5C146.2,3.5,146.4,3.6,147.3,3.5z"
            />
            <path
                fill={color}
                d="M188.5,3.2c1.2,0.2,1.4-0.1,1.8-0.4C189.3,2.7,188.9,2.9,188.5,3.2z"
            />
            <path
                fill={color}
                d="M34.1,3.9c0.2,0,0.5,0,0.5-0.1c0-0.1-0.1-0.2-0.1-0.4c-0.3,0.1-0.5,0.2-0.5,0.2C33.8,3.7,34,3.8,34.1,3.9z"
            />
            <path fill={color} d="M31.3,3.4c0.3-0.1,0.6-0.3,1-0.4C31,3,31,3,31.3,3.4z" />
            <path
                fill={color}
                d="M25.2,3.6c0.1,0,0.4,0,0.4,0c0-0.1,0.1-0.2,0.1-0.3c-0.2,0-0.4,0-0.6,0C25.1,3.4,25.1,3.5,25.2,3.6z"
            />
            <path
                fill={color}
                d="M17.1,2.8c0.2,0,0.4,0.1,0.5,0.1c0.2,0,0.3-0.1,0.5-0.1c-0.2,0-0.3-0.1-0.6-0.2C17.3,2.7,17.2,2.7,17.1,2.8z"
            />
            <path
                fill={color}
                d="M56.1,2.7c0.2,0.1,0.4,0.1,0.6,0.2c0.1,0,0.3-0.1,0.5-0.1c-0.2-0.1-0.3-0.1-0.5-0.2
    		C56.4,2.6,56.3,2.6,56.1,2.7z"
            />
            <path
                fill={color}
                d="M66.4,3.7c0,0.1,0.3,0.1,0.4,0.2c0.1-0.1,0.3-0.1,0.4-0.2c-0.2-0.1-0.4-0.1-0.5-0.1
    		C66.6,3.5,66.4,3.6,66.4,3.7z"
            />
            <path
                fill={color}
                d="M77.8,4.8c0,0.1,0.3,0.1,0.5,0.1c0.2,0,0.4-0.1,0.5-0.1c0-0.1-0.1-0.1-0.5-0.4C77.9,4.7,77.7,4.8,77.8,4.8z"
            />
            <path
                fill={color}
                d="M53.3,4.1c0.2,0,0.4-0.1,0.4-0.1c0-0.1-0.1-0.1-0.2-0.3c-0.2,0.1-0.4,0.2-0.5,0.2C53.1,4,53.2,4,53.3,4.1z"
            />
            <path
                fill={color}
                d="M50.8,3.7c0-0.1-0.2-0.1-0.4-0.2c-0.1,0.1-0.3,0.1-0.3,0.2c0,0.1,0.2,0.1,0.4,0.2C50.7,3.8,50.8,3.7,50.8,3.7z
    		"
            />
            <path
                fill={color}
                d="M56.1,5c0.2,0,0.3-0.1,0.5-0.1c-0.2,0-0.3-0.1-0.6-0.2c-0.2,0.1-0.3,0.1-0.4,0.2C55.7,4.9,55.9,5,56.1,5z"
            />
        </g>
    </svg>
);

TitleLarge.propTypes = propTypes;
TitleLarge.defaultProps = defaultProps;

export default TitleLarge;
